import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/www/src/components/mdx/index.tsx";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`🛠️ Fixit Week`}</h2>
    <p>{`Each team spent the first full week back cleaning up their issue backlogs.`}</p>
    <ul>
      <li parentName="ul">{`For Web we closed 14 issues, improving our documentation build and updating a few visual changes to components.`}</li>
      <li parentName="ul">{`The Android team updated documentation for button and dropdown.`}</li>
      <li parentName="ul">{`And our iOS team worked on updating animation and corner radius tokens and is finalizing alert banners and toasts.`}</li>
    </ul>
    <h2>{`📅 2020 Plans`}</h2>
    <p>{`We made great strides in 2019 to get to near parity between our web and native platforms. We’ll continue this work with new components, revisiting existing ones, and explore ways of improving designer and developer productivity.`}</p>
    <p>{`Among the projects we’ll be tackling…`}</p>
    <ul>
      <li parentName="ul">{`Updated documentation to better integrate native components and guidelines`}</li>
      <li parentName="ul">{`Open-sourcing Thumbprint Native`}</li>
      <li parentName="ul">{`Thumbprint for Emails, a proper design system`}</li>
      <li parentName="ul">{`More Figma plugins`}</li>
      <li parentName="ul">{`Component adoption tracking`}</li>
      <li parentName="ul">{`Work more closely with user research`}</li>
      <li parentName="ul">{`More blog posts and conference talks`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      